import React, { useEffect, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, TableCell, Tooltip } from '@mui/material';

import { PaginationTable } from './paginationTable';
import { ConfirmDialog } from 'src/components/custom-dialog';
import Logger from 'src/lib/Logger';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { axiosGetCall, axiosPostCall } from 'src/services/apisCall';
const logger = new Logger('CreditNegativeBalanceList');

const columns = [
  { id: 'user_id', label: 'User ID', minWidth: 20, align: 'center' },
  { id: 'plan_id', label: 'Plan ID', minWidth: 110, align: 'center' },
  { id: 'TotBal', label: 'Total Credit', minWidth: 110, align: 'center' },
  { id: 'CurrBal', label: 'Current Credit', minWidth: 110, align: 'center' },
  { id: 'Validity', label: 'Validity', minWidth: 20, align: 'center' },
  { id: 'Pulse', label: 'Pulse', minWidth: 20, align: 'center' },
  { id: 'actions', label: 'Action', minWidth: 20, align: 'center' },
];

export const CreditNegativeBalanceList = ({ loadit }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);

  const [search, setSearch] = useState('');
  const [load, setLoad] = useState(true);
  const [networkError, setNetworkError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openRemove, setOpenRemove] = useState(false);

  const handleChange = (value) => setSearch(value);

  const handleRemoveClick = (user) => {
    setSelectedUser(user);
    setOpenRemove(true);
  };

  const handleCloseRemove = () => {
    setOpenRemove(false);
    setSelectedUser(null);
  };

  const handleConfirmRemove = async () => {
    const payload = {
      actionUserId: selectedUser?.user_id,
      planId: selectedUser?.plan_id,
      type: 'credit',
    };
    try {
      const response = await axiosPostCall('removeNegativeBalanceUser', payload);
      renderSuccessMessage(response?.message);
      await GetAmountNegativeList();
      handleCloseRemove();
    } catch (error) {
      logger.error('Remove negative credit balance user', error);
      renderErrorMessage(error?.message);
    }
  };

    const GetAmountNegativeList = async () => {
        const skip = rowsPerPage * page;
        try {
            const params = { 
                skip,
                limit: rowsPerPage,
                type: "credit",
            }
            
            setNetworkError(false)
            const response = await axiosGetCall("getNegativeUsersBalanceList", params)
            setRows(response?.data)
            setCount(response?.total || 0)
        } catch (error) {
            logger.error("NegativeUsersBalanceList", error);
            setNetworkError(true)
            setRows([])
            setCount(0)
            renderErrorMessage(error?.message)
        }
        setLoading(false)
    }

  useEffect(() => {
    setLoading(true);
    GetAmountNegativeList();
    setLoad(false);
  }, [load, loadit]);

  const ActionJsx = ({ id, align, row }) => (
    <TableCell
      key={id}
      align={align}
      sx={{ color: 'grey.400', borderBottom: '0.5px dashed', borderColor: 'grey.300', size: 'small' }}
    >
      <Tooltip title="Remove from negative list">
        <IconButton aria-label="Remove from negative list" onClick={() => handleRemoveClick(row)}>
          <DeleteIcon sx={{ color: '#d32f2f', height: '18px', width: '18px' }} />
        </IconButton>
      </Tooltip>
    </TableCell>
  );

  return (
    <>
      {/* <ToastContainer /> */}
      <PaginationTable
        page={page}
        setLoad={setLoad}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        count={count}
        error={networkError}
        loading={loading}
        setLoading={setLoading}
        rows={rows}
        columns={columns}
        handleChange={handleChange}
        search={search}
        calculatedHeight={288}
        ActionJsx={ActionJsx}
      />

      <ConfirmDialog
        open={openRemove}
        onClose={handleCloseRemove}
        title="Remove Negative User"
        content={
          <span>
            Are you sure you want to remove user <strong>{selectedUser?.user_id || ''}</strong> from the{' '}
            <strong>negative credit list</strong>?
          </span>
        }
        action={
          <Button
            color="error"
            variant="contained"
            sx={{ color: '#fff', height: '30px', boxShadow: 'none', marginRight: '10px' }}
            onClick={handleConfirmRemove}
          >
            Remove
          </Button>
        }
      />
    </>
  );
};
